import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, unref as _unref, resolveDynamicComponent as _resolveDynamicComponent, createBlock as _createBlock, KeepAlive as _KeepAlive, Transition as _Transition, withCtx as _withCtx, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-0a8ef25f"),n=n(),_popScopeId(),n)
const _hoisted_1 = { id: "contact" }
const _hoisted_2 = { class: "contact-card" }
const _hoisted_3 = { class: "contact-header" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h3", null, "Eventanfrage", -1))
const _hoisted_5 = {
  key: 0,
  class: "error-container"
}
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h3", null, "Es ist ein Fehler aufgetreten :(", -1))
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "Die Anfrage konnte leider nicht gesendet werden.", -1))
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "Probiere es noch einmal oder kontaktiere mich gerne per E-Mail: info@herrdaub.de oder telefonisch unter 01724890833", -1))
const _hoisted_9 = [
  _hoisted_6,
  _hoisted_7,
  _hoisted_8
]
const _hoisted_10 = {
  key: 1,
  class: "contact-body"
}
const _hoisted_11 = {
  key: 2,
  class: "confirm-container"
}
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "Danke für die unverbindliche Anfrage :)", -1))
const _hoisted_13 = ["src"]

import { shallowRef, ref } from 'vue';
import ProgressSteps from './ProgressSteps.vue';
import { sendEmailConfirmation } from '@/remoteService/emailService';


export default /*#__PURE__*/_defineComponent({
  __name: 'ContactForm',
  props: {
    items: null
  },
  setup(__props: any) {

const props = __props as {
  items: { label: string, component: any, icon: string }[];
};



const formSend = ref<boolean>(false);
const sendError = ref<boolean>(false);

const currentPage = ref(0);
const formInView = shallowRef(props.items[0].component);
const transitionMove = ref<'right' | 'left'>('left');
const formData: Record<string, any> = {};

const saveData = (data: Record<string, any>) => {
  const key = Object.values(props.items)[currentPage.value].label;
  formData[key] = data;
  changePage(1);
}

const changePage = (delta: -1 | 1) => {
  if ((delta === 1 && currentPage.value < props.items.length) || (delta === -1 && currentPage.value > 0)) {
    transitionMove.value = delta > 0 ? 'left' : 'right';
    currentPage.value += delta;
    formInView.value = props.items[currentPage.value].component;
  }
}

const submitForms = async (data: Record<string, any>) => {
  const key = Object.values(props.items)[currentPage.value].label;
  formData[key] = data;
  sendEmailConfirmation(formData)
    .then(() => {
      formSend.value = true;
      currentPage.value += 1;
    })
    .catch((error) => {
      sendError.value = true;
      console.log(error);
    });
}



return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("article", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _hoisted_4,
        _createVNode(ProgressSteps, {
          items: props.items,
          progress: currentPage.value
        }, null, 8, ["items", "progress"])
      ]),
      (sendError.value)
        ? (_openBlock(), _createElementBlock("div", _hoisted_5, _hoisted_9))
        : (!formSend.value)
          ? (_openBlock(), _createElementBlock("div", _hoisted_10, [
              _createVNode(_Transition, {
                name: `transition${transitionMove.value}`
              }, {
                default: _withCtx(() => [
                  (_openBlock(), _createBlock(_KeepAlive, null, [
                    (_openBlock(), _createBlock(_resolveDynamicComponent(_unref(formInView)), {
                      onOnNextClick: saveData,
                      onOnPrevClick: _cache[0] || (_cache[0] = ($event: any) => (changePage(-1))),
                      onOnSend: submitForms,
                      class: "form-component"
                    }, null, 32))
                  ], 1024))
                ]),
                _: 1
              }, 8, ["name"])
            ]))
          : (_openBlock(), _createElementBlock("div", _hoisted_11, [
              _hoisted_12,
              _createElementVNode("img", {
                src: require('@/assets/media/images/dd.png'),
                alt: ""
              }, null, 8, _hoisted_13)
            ]))
    ])
  ]))
}
}

})